import type { FilterTag } from '../components/FilterTags';
import type { Category, SearchFilters, Specialty } from '../types';

type BuildProviderDirectoryFilterTagsArgs = {
  filters: SearchFilters;
  categories: Category[];
  specialties: Specialty[];
};

export const buildProviderDirectoryFilterTags = ({
  filters,
  categories,
  specialties,
}: BuildProviderDirectoryFilterTagsArgs): FilterTag[] => {
  const tags: FilterTag[] = [];
  const isFinancialAdvisorMode = filters.providerType === 'FINANCIAL_ADVISOR';

  if (filters.providerName) {
    tags.push({
      id: 'provider-name',
      label: 'Name',
      value: filters.providerName,
      type: 'providerName',
    });
  }

  if (!isFinancialAdvisorMode && filters.categoryIds) {
    filters.categoryIds.forEach((id) => {
      const category = categories.find((item) => item.id === id);
      if (category) {
        tags.push({
          id: `category-${id}`,
          label: 'Category',
          value: category.name,
          type: 'category',
        });
      }
    });
  }

  if (!isFinancialAdvisorMode && filters.specialtyIds) {
    filters.specialtyIds.forEach((id) => {
      const specialty = specialties.find((item) => item.id === id);
      if (specialty) {
        tags.push({
          id: `specialty-${id}`,
          label: 'Specialty',
          value: specialty.name,
          type: 'specialty',
        });
      }
    });
  }

  if (filters.locationAddress) {
    tags.push({
      id: 'location',
      label: 'Location',
      value: filters.locationAddress,
      type: 'location',
    });
  }

  return tags;
};
